export default __webpack_public_path__ + "static/prof-app-2-cae7ca6309768404cc45418bcbb97eef.png";